import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Devis from "./pages/Devis";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home seoKey="home" />} />
            <Route path="/configurateur" element={<Home seoKey="configurateur" />} />
            <Route path="/estimation" element={<Home seoKey="estimation" />} />
            <Route path="/realisations" element={<Home seoKey="realisations" />} />
            <Route path="/avis" element={<Home seoKey="avis" />} />
            <Route path="/diagnostic-facade" element={<Home seoKey="diagnostic" />} />
            <Route path="/isolation-thermique" element={<Home seoKey="isolationThermique" />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/faq" element={<Home seoKey="faq" />} />
            <Route path="/zones-intervention" element={<Home seoKey="zones" />} />
            <Route path="/contact" element={<Home seoKey="contact" />} />

            {/* Pages SEO service + ville */}
            <Route path="/ravalement-facade-valenciennes" element={<ServicePage pageKey="ravalementFacadeValenciennes" />} />
            <Route path="/isolation-thermique-exterieure-valenciennes" element={<ServicePage pageKey="isolationThermiqueValenciennes" />} />
            <Route path="/rejointoiement-briques-valenciennes" element={<ServicePage pageKey="rejointoiementBriquesValenciennes" />} />
            <Route path="/nettoyage-facade-valenciennes" element={<ServicePage pageKey="nettoyageFacadeValenciennes" />} />
            <Route path="/ravalement-facade-anzin" element={<ServicePage pageKey="ravalementAnzin" />} />
            <Route path="/ravalement-facade-marly" element={<ServicePage pageKey="ravalementMarly" />} />
            <Route path="/ravalement-facade-saint-saulve" element={<ServicePage pageKey="ravalementSaintSaulve" />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            {/* Fallback : toute URL inconnue → page 404 (noindex) */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
